import { cloneDeep } from "lodash";
import { SearchAliasItemKeys } from "../constants/formValidationSchemas";
import {
	ProductFAQs,
	ProductFeature,
	ProductKeys,
	ProductLegalDetailEnums,
	ProductLogo,
	ProductQuickStartConfig,
	ProductSupportEnums,
} from "../constants/product";
import type { SearchAliasesItems } from "../types/generated-graphql";

// Used to set replace "" with null
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- deeply nested dynamic property access requires any
export function MakeEmptyFieldNull(data: Record<string, any>) {
	const requestData = cloneDeep(data);
	// General Tab
	// Logo
	if (requestData[ProductKeys.logo] && !requestData[ProductKeys.logo][ProductLogo.url]) {
		// sets empty value
		requestData[ProductKeys.logo][ProductLogo.url] = null;
	}
	// Features & Benefits tab
	if (requestData[ProductKeys.features]) {
		const featuresData = requestData[ProductKeys.features].filter(
			(item: Record<string, string>) => item[ProductFeature.title] && item[ProductFeature.description],
		);
		requestData[ProductKeys.features] = featuresData.length === 0 ? null : featuresData;
	}
	// Quick start tab
	// Quick start field
	if (
		requestData[ProductKeys.quickStartConfig] &&
		!requestData[ProductKeys.quickStartConfig][ProductQuickStartConfig.instructions]
	) {
		requestData[ProductKeys.quickStartConfig][ProductQuickStartConfig.instructions] = null;
	}
	// FAQ Tab
	if (requestData[ProductKeys.faqs]) {
		const faqData = requestData[ProductKeys.faqs].filter(
			(item: Record<string, string>) => item[ProductFAQs.question] && item[ProductFAQs.answer],
		);
		requestData[ProductKeys.faqs] = faqData.length === 0 ? null : faqData;
	}
	// Legal tab
	// License agreement field
	if (requestData[ProductKeys.legal] && !requestData[ProductKeys.legal][ProductLegalDetailEnums.licenseAgreementUrl]) {
		requestData[ProductKeys.legal][ProductLegalDetailEnums.licenseAgreementUrl] = null;
	}
	// Privacy policy field
	if (requestData[ProductKeys.legal] && !requestData[ProductKeys.legal][ProductLegalDetailEnums.privacyPolicyUrl]) {
		requestData[ProductKeys.legal][ProductLegalDetailEnums.privacyPolicyUrl] = null;
	}

	// Support tab
	// Phone number
	if (requestData[ProductKeys.support] && !requestData[ProductKeys.support][ProductSupportEnums.phoneNumber]) {
		requestData[ProductKeys.support][ProductSupportEnums.phoneNumber] = null;
	}
	// Email id
	if (requestData[ProductKeys.support] && !requestData[ProductKeys.support][ProductSupportEnums.emailAddress]) {
		requestData[ProductKeys.support][ProductSupportEnums.emailAddress] = null;
	}
	// Support description
	if (requestData[ProductKeys.support] && !requestData[ProductKeys.support][ProductSupportEnums.description]) {
		requestData[ProductKeys.support][ProductSupportEnums.description] = null;
	}

	// FAQ Tab
	// questions and answers
	if (requestData[ProductKeys.faqs]) {
		const filteredFAQ = requestData[ProductKeys.faqs].filter(
			(item: Record<string, string>) => item[ProductFAQs.answer] && item[ProductFAQs.question],
		);
		requestData[ProductKeys.faqs] = filteredFAQ.length > 0 ? filteredFAQ : null;
	}

	// SEO Tab
	// Search aliases - filter out empty key-value pairs
	if (requestData[ProductKeys.searchAliases]) {
		const filteredSearchAliases = requestData[ProductKeys.searchAliases].filter(
			(item: SearchAliasesItems) => item[SearchAliasItemKeys.key]?.trim() && item[SearchAliasItemKeys.value]?.trim(),
		);
		requestData[ProductKeys.searchAliases] = filteredSearchAliases?.length > 0 ? filteredSearchAliases : [];
	}
	return requestData;
}
